import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import reupload from 'images/reupload.svg'
import fileSizeWarning from 'images/fileSizeWarning.svg'
import { Card, CardBody, CardContent, CardFileIcon, CardSubTitle, CardTitle } from './cardStyles'
import ProgressBar from 'components/ProgressBar'
import { getDocName } from 'hooks/useDocListData'
import { MESSAGES } from '../../messages/messages'

const FileSizeErrorCard = ({ id, progressCount = 0, selectFile = () => {}, onKeyDownHandler = () => {}, ...props }) => {
    const documentName = getDocName(props)

    return (
        <Card
            tabIndex={0}
            data-testid={id}
            sx={{
                border: (theme) => `1.5px solid ${theme.palette.common.alert.main}`,
                justifyContent: 'flex-end',
                boxShadow: '0'
            }}
            onClick={selectFile}
            onKeyDown={onKeyDownHandler}
        >
            <CardBody>
                <CardContent>
                    <CardFileIcon>
                        <img
                            data-testid="icon"
                            src={fileSizeWarning}
                            alt={'file size waring icon'}
                            width={16}
                            height={16}
                        />
                    </CardFileIcon>
                    <Box>
                        <CardTitle data-testid="document-name">{documentName}</CardTitle>
                        <CardSubTitle
                            data-testid="status"
                            sx={{
                                color: 'common.alert.main'
                            }}
                        >
                            {MESSAGES.FILESIZEERROR_DESC}
                        </CardSubTitle>
                    </Box>
                </CardContent>
                <Box
                    aria-label="reupload icon"
                    data-testid="action"
                    sx={{
                        p: 0
                    }}
                >
                    <img src={reupload} alt={'reupload icon'} width={24} height={24} />
                </Box>
            </CardBody>
            <ProgressBar value={progressCount} color="common.alert.main" />
        </Card>
    )
}

FileSizeErrorCard.propTypes = {
    id: PropTypes.number,
    selectFile: PropTypes.func,
    progressCount: PropTypes.number,
    onKeyDownHandler: PropTypes.func
}

export default FileSizeErrorCard
